var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown"},[(_vm.countdownText && _vm.textShow)?_c('div',{staticClass:"count-text"},[_vm._v(" "+_vm._s(_vm.countdownText)+" ")]):_vm._e(),_c('div',{staticClass:"count-time",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }